import { render, staticRenderFns } from "./JobNonConformitiesCard.vue?vue&type=template&id=1849584e&scoped=true&"
import script from "./JobNonConformitiesCard.vue?vue&type=script&lang=js&"
export * from "./JobNonConformitiesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1849584e",
  null
  
)

export default component.exports